import React from "react";
import styled from "styled-components";
import { DoubleArrow, SingleArrow } from "../../Common/SvgIcon/CommonSvgIcons";

const StartTimeDiv = styled.div`
font-family: Inter;
font-weight: 400;
font-style: Regular;
font-size: 14px;
leading-trim: NONE;
line-height: 100%;
letter-spacing: 0%;
color:rgba(50, 50, 50, 1);

`;
const StyledBtn = styled.button`
  width: 27px;
  height: 28px;
  border: 1px solid #ccc;
  cursor: pointer;

  background: ${(props) =>
        props.disabled ? "#e0e0e0" : "rgba(27, 125, 93, 1)"};

  color: ${(props) =>
        props.disabled ? "#9e9e9e" : "white"};

  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};

  display: flex;
  align-items: center;
  justify-content: center;
`;

const Pagination = ({
    currentPage = 0,
    totalPages = 0,
    setCurrentPage,
    totalItems = 0,
    startItem = 0,
    endItem = 0,
}) => {
    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;

        let start = Math.max(1, currentPage - 2);
        let end = Math.min(totalPages, start + maxVisible - 1);

        if (end - start < maxVisible - 1) {
            start = Math.max(1, end - maxVisible + 1);
        }

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        return pages;
    };

    return (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 20 }}>

            <StartTimeDiv>
                {/* {startItem}-{endItem} of {totalItems} items */}
            </StartTimeDiv>

            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <StyledBtn
                    disabled={currentPage === 1} style={{ transform: 'rotate(180deg)' }} onClick={() => setCurrentPage(1)}>{DoubleArrow}</StyledBtn>
                <StyledBtn
                    disabled={currentPage === 1} style={{ transform: 'rotate(180deg)' }} onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>{SingleArrow}</StyledBtn>

                {getPageNumbers().map((page) => (
                    <StyledBtn
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        style={{
                            background: currentPage === page ? "rgba(27, 125, 93, 1)" : "white",
                            color: currentPage === page ? "white" : "black",
                            padding: "5px 10px",
                            border: "1px solid #ccc"
                        }}
                    >
                        {page}
                    </StyledBtn>
                ))}

                <StyledBtn disabled={currentPage === totalPages} onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}>{SingleArrow}</StyledBtn>
                <StyledBtn disabled={currentPage === totalPages} onClick={() => setCurrentPage(totalPages)} >{DoubleArrow}</StyledBtn>
            </div>

            <div>
            </div>
        </div>
    );
};

export default Pagination;